<template>
  <v-container fluid>
    <v-layout row wrap text-xs-center>

      <v-dialog v-model="show" persistent="true" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="justify-center">
          <img class="align-center" src="@/assets/logo.jpg" alt="">
          <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 class="text-xs-center">
            <h2>Tu suscripción se ha realizado correctamente</h2>
          </v-flex>
          <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 class="text-xs-center" v-if="advice">
            <h3>Descarga la app de Planet Horror para una mejor experiencia de usuario</h3>
              <a href="https://itunes.apple.com/es/app/planet-horror/id1457682357?mt=8" target="_blank">
              <img class="button-appstore" src="/ios.png"></a>
          </v-flex>

          <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 class="text-xs-center">
            <h2>¿Te gustaría recibir información sobre las novedades de AMC Networks y sus socios comerciales?</h2>
          </v-flex>

          <v-btn color="primary" class="align-center-btn" width="340px"
            @click="okRedirect(true)">Continuar</v-btn>
          <v-btn class="align-center-btn" width="340px"
            @click="okRedirect();">No</v-btn>
        </v-card>
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data: () => ({
    show: true,
    advice: false
  }),
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['updateUserPrivacy']),
    okRedirect (enableNotifications) {
      let allow_communications = false
      const privacy = JSON.parse(localStorage.getItem('privacy'))
      const terms = JSON.parse(localStorage.getItem('terms'))
      if (enableNotifications) allow_communications = true
        console.log('user:::', this.user)
      this.updateUserPrivacy({
        id: this.user.id, allow_communications, privacy, terms
      })
      // this.$router.replace({ name: 'Subscription' })
      this.redirect()
    },
    check () {
      this.show = true
      if(/webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
        this.advice = true
      }
    },
    redirect () {
      if (this.$route.query.from) {
        return this.$router.replace({
          name: 'Video',
          params: {
            id: this.$route.query.from.split('/')[2]
          }
        })
      } else {
        return this.$router.replace({ name: 'Home' })
      }
    }
  },
  activated () {
    this.check()
    window.fbq('track', 'CompleteRegistration')
    window.gtag('event', 'conversion', {
      'send_to': 'AW-743809320/t3hTCLjS0KIBEKjC1uIC',
      'transaction_id': ''
    })
    window.adperf_conversion(285)
  }
}
</script>
<style scoped>
  .align-center {
    margin-top: 10%;
    margin-left: calc(50% - 165px);
  }
  .align-center-btn {
    display: block;
    margin-left: calc(50% - 136px);
  }
  .button-appstore {
    width: 150px;
    margin: auto 10px;
  }
</style>
<style>
  .align-center-btn * {
    width: 240px;
  }
</style>
